import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, TextField, FormControl,
  InputLabel, Select, MenuItem, IconButton, CircularProgress,
  makeStyles
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useSelector } from 'react-redux';
import { STATUS_API } from 'src/app/constant/config';

const MOVEMENT_TYPES = [
  { value: 'IMPORT', label: '📥 Nhập kho', color: '#27ae60' },
  { value: 'EXPORT', label: '📤 Xuất kho', color: '#e67e22' },
  { value: 'ADJUST', label: '⚖️ Điều chỉnh', color: '#2980b9' },
  { value: 'DAMAGED', label: '🚫 Hỏng/mất', color: '#e74c3c' }
];

const useStyles = makeStyles(() => ({
  dialogTitle: {
    background: 'linear-gradient(135deg, #D9042F 0%, #a80020 100%)',
    color: '#fff',
    padding: '16px 24px'
  },
  titleText: { fontWeight: 700, fontSize: 17, color: '#fff' },
  closeBtn: { color: '#fff' },
  saveBtn: {
    backgroundColor: '#D9042F !important',
    color: '#fff !important',
    fontWeight: 700,
    borderRadius: 8,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#b30222 !important'
    },
    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5 !important',
      color: '#c0c0c0 !important'
    }
  },
  dialogContent: {
    '& input::placeholder': {
      fontSize: '12px !important'
    },
    '& textarea::placeholder': {
      fontSize: '12px !important'
    }
  }
}));

const StockAdjustDialog = ({
  open,
  onClose,
  defaultProduct,
  products = [],
  agencies = [],
  defaultAgencyId = '',
  onAdjust
}) => {
  const classes = useStyles();
  const { statusAdjust } = useSelector(state => state.productSlice);

  const [form, setForm] = useState({
    product_id: '',
    quantity: '',
    note: ''
  });

  useEffect(() => {
    if (open) {
      setForm({
        product_id: defaultProduct?.id || '',
        quantity: '',
        note: ''
      });
    }
  }, [open, defaultProduct]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.product_id || !form.quantity) return;
    const vmakeAgency = (agencies || []).find(a => a.name?.toLowerCase()?.includes('vmake')) || { id: 1 };
    onAdjust({
      product_id: Number(form.product_id),
      agency_id: vmakeAgency.id,
      type: 'IMPORT',
      quantity: Number(form.quantity),
      note: form.note || undefined
    });
  };

  const isLoading = statusAdjust === STATUS_API.PENDING;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography className={classes.titleText}>Nhập kho phụ kiện</Typography>
          <IconButton size="small" className={classes.closeBtn} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers className={classes.dialogContent}>
        <Box display="flex" flexDirection="column" style={{ gap: 16, paddingTop: 8 }}>
          <Box>
            <InputLabel style={{ fontSize: 13, color: '#1a1f36', fontWeight: 600, marginBottom: 4 }}>
              Sản phẩm
            </InputLabel>
            <TextField
              className="input-no-fieldset"
              value={defaultProduct ? `[${defaultProduct.code || ''}] ${defaultProduct.name || ''}` : ''}
              variant="outlined"
              size="small"
              fullWidth
              disabled
            />
          </Box>

          <Box>
            <InputLabel style={{ fontSize: 13, color: '#1a1f36', fontWeight: 600, marginBottom: 4 }}>
              Số lượng nhập <span style={{ color: 'red' }}>*</span>
            </InputLabel>
            <TextField
              className="input-no-fieldset"
              name="quantity"
              value={form.quantity}
              onChange={handleChange}
              variant="outlined"
              size="small"
              fullWidth
              type="number"
              inputProps={{ min: 1 }}
              required
            />
          </Box>

          <Box>
            <InputLabel style={{ fontSize: 13, color: '#1a1f36', fontWeight: 600, marginBottom: 4 }}>
              Ghi chú
            </InputLabel>
            <TextField
              className="input-no-fieldset"
              name="note"
              value={form.note}
              onChange={handleChange}
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={2}
              placeholder="Lý do nhập kho..."
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions style={{ padding: '12px 24px', gap: 8 }}>
        <Button onClick={onClose} variant="outlined" style={{ borderRadius: 8, textTransform: 'none' }}>
          Hủy
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          className={classes.saveBtn}
          disabled={isLoading || !form.product_id || !form.quantity}
          startIcon={isLoading ? <CircularProgress size={16} style={{ color: '#fff' }} /> : null}
        >
          {isLoading ? 'Đang xử lý...' : 'Xác nhận'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockAdjustDialog;
